import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar dark />
      <main>
        <ContactHero />

        <section className="w-full bg-background-100 px-4 md:px-8 lg:px-12 py-14 md:py-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
            <ContactForm />
            <ContactInfo />
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}